/**
 * @file Basic spinner component for loading states.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
};

const Spinner = ({ className, light, size, ...props }) => {
  const classes = classNames({
    spinner: !size,
    'spinner-xs': size === 'xs',
    'spinner-sm': size === 'sm',
    'spinner-lg': size === 'lg',
    'spinner-light': light,
    [className]: !!className,
  });

  return (
    <span className={classes} role="status" data-testid="spinner" {...props} />
  );
};

Spinner.propTypes = propTypes;

export default Spinner;
